import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { NonBillableSOWInterface } from "./@types";

export const fetchActivityItemTable = async (
  supplierCode: string
) => {
  const { data } = await apiInputService.get(
    `/Sow/supplierCode/${supplierCode}`,
    {
      params: {
        active: true,
        sowUverifyType: "SUPPLIER",
      },
    }
  );

  return data;
};

export const useActivityItemsWithSupplierCode = (
  supplierCode: string,
  options?: any
) => {
  return useQuery<NonBillableSOWInterface[]>(
    ["activity-items-with-supplierCode", supplierCode],
    () => fetchActivityItemTable(supplierCode),
    {
      enabled: Boolean(supplierCode),
      ...options,
    }
  );
};
